import React, { ReactNode, useMemo, useState } from 'react'
import LeftMenu from './partials/LeftMenu/LeftMenu'
import RightMenuNew from './partials/RightMenu/RightMenuNew'
import FooterNew from './partials/Footer/FooterNew'
import styles from './Layout.module.scss'
import HeaderNew from './partials/Header/HeaderNew'
import { cn } from 'utils'
import '../../css/menu.scss'

interface OwnProps {
  oldCss?: boolean
  children?: ReactNode
  contentMaxWidth?: boolean
}

const OldCssContainer = ({ children }: { children?: ReactNode }) => {
  return <div className="old-kl-css">{children}</div>
}

const NewCssContainer = ({ children }: { children?: ReactNode }) => {
  return <>{children}</>
}


const LayoutNew = ({ children, contentMaxWidth, oldCss }: OwnProps) => {
  const [isRightMenuOpened, setIsRightMenuOpened] = useState(false)

  const handleFriendsClick = () => {
    setIsRightMenuOpened(!isRightMenuOpened)
  }

  const Container = useMemo(() => {
    return oldCss ? OldCssContainer : NewCssContainer
  }, [oldCss])


  return (
    <>
      <HeaderNew onFriendsClick={handleFriendsClick} />
      <div className="container-fluid m-t-sm-60 m-t-lg-82 p-l-lg-135 p-l-sm-85 p-l-sm-65">
        <div className="row flex-nowrap">
          <LeftMenu />
          <div className={cn('col', contentMaxWidth && styles.colMainContentMaxWidth)}>
            <Container>
              <article className={cn(styles.article, oldCss && 'article', oldCss && styles.oldCss)}>
                <div className="container-fluid">{children}</div>
              </article>
            </Container>
            <FooterNew />
          </div>
          <RightMenuNew isOpened={isRightMenuOpened} setIsRightMenuOpened={setIsRightMenuOpened} />
        </div>
      </div>
    </>
  )
}

export default LayoutNew
